import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from '@/routes';
import FunnelLoader from '@/components/FunnelLoader';
import { useTrackingInitialize, usePageTracking } from '@/hooks/useTracking';
import { useUTMCapture } from '@/hooks/useUTMCapture';
import { useFunnelConfig } from '@/context/FunnelConfigContext';

const App = () => {
  // ALL HOOKS MUST BE CALLED FIRST, BEFORE ANY CONDITIONAL RETURNS
  // This ensures consistent hook order across all renders

  // Wait for funnel config (and therefore primary color) to be ready
  const { config, loading } = useFunnelConfig();

  // Capture UTM params from URL on load and persist to sessionStorage
  useUTMCapture();
  
  // Initialize tracking services (Google Analytics & Facebook Pixel)
  // Pass config to avoid duplicate useFunnelConfig calls
  useTrackingInitialize(config, loading);
  
  // Track page views on route changes
  usePageTracking();
  
  // Call useRoutes hook BEFORE any conditional returns
  // This ensures the hook is always called in the same position
  const routeElement = useRoutes(routes);

  // Early return after all hooks are called
  if (loading && !config) {
    return <FunnelLoader />;
  }

  return (
    <Suspense fallback={<FunnelLoader />}>
      {routeElement}
    </Suspense>
  );
};

export default App;